import { useState, useRef, useEffect } from "react";
import "./Withdraw.less";
import NavBar from '@/component/NavBar/NavBar';
import { Form, Input, Button, Dialog, Image, Modal, Mask, SpinLoading } from 'antd-mobile'
import { DialogShowHandler } from 'antd-mobile/es/components/dialog'
import { RightOutline, CloseCircleOutline } from 'antd-mobile-icons'
import BankPng from '@/image/Bank.png'
import AlipayPng from '@/image/recharge/Alipay.svg'
import { useParams } from 'react-router-dom';
import { getAccountInfo, postWithdrawCalc, postWithdrawApply, getSignAnchorTaxProtocal, getSignAnchorProtocal } from '@/api/my-wallet'
import { CalcInfoData, WithdrawChannelListData } from '@/interface/withdraw'
// import { connect } from "react-redux";
import { store } from '@/store'
import { jumpPage, debounce, throttle } from '@/utils/common'
import { useHistory } from 'react-router-dom'
import { filterMoney } from '@/utils/filter'
// 图片
import editFilePng from '@/image/withdraw/edit_file.png'

const Withdraw = () => {
  const history = useHistory()
  const [active, setActive] = useState(0)
  const [value, setValue] = useState('')
  const handler = useRef<DialogShowHandler>()
  const { platform_number }:any = useParams();
  const [platform_info, setPlatformInfo] = useState({
    platform_number: '',//平台编码
    withdraw_channel: [''],//渠道编码 bankcard
    service_rates: 0,//服务费率
  })
  const [account, setAccount] = useState({
    amount: 0,//我的熊猫币数量
    bank_card_withdraw_num: 0,//银行卡次数
    alipay_withdraw_num: 0,//支付宝次数
    today_quota: 0,//今日可申请额度,当今日剩余次数等于0时不显示该字段
    month_quota: 0,//月剩余额度
    user_id: 0,
  })
  const [is_user_tax_related, setis_user_tax_related] = useState<string>('') // 用户是否签署增值税协议 Y 已签署 N 未签署
  const [is_sign_protocol, setIsSignProtocol] = useState<number>(0) // 是否签署协议（0未签署, 1已签署）
  const [guild_id, setGuildId] = useState<number>(0)
  const [withdraw_channel_list, setWithdrawChannelList] = useState<Array<WithdrawChannelListData>>([])
  const [maskVisible, setMaskVisible] = useState<boolean>(false) 

  // 获取携带在本地的签约平台信息
  const sign:{[index:string]:any}= store.getState().sign.signPlatform;

  useEffect(() => {
    getAccountInfo(platform_number).then(e => {
      setPlatformInfo(e.platform_info)
      setAccount(e.account)
      setis_user_tax_related(e.is_user_tax_related)
      setIsSignProtocol(e.is_sign_protocol)
      setGuildId(e.guild_id)
      if (e.is_user_tax_related !== 'Y') setVisible(true)
      else if (e.is_sign_protocol !== 1) setVisible2(true)
      setWithdrawChannelList(e.withdraw_channel_list || [])
    }).catch(() => {})
  }, [platform_number])

  const buttonClick = () => {
    jumpPage('/withdraw-record')
  }

  const primaryVal:CalcInfoData = {
    amount: 0, // 提现金额
    handling_fee_amount: 0, // 手续费
    real_amount: 0, // 实际到账
    tax_rate: 0, // 税费
    withdraw_account: '', // 提现账号(脱敏)
    withdraw_channel: '', // 提现渠道
  }

  const [calcInfo, setCalcInfo] = useState<CalcInfoData>(primaryVal)

  const trigWithDrawCalc = (amount:number, i?:number) => {
    const index = (i !== undefined && i !== null) ? i : active;
    const data = {
      platform_number,
      amount,
      withdraw_channel: withdraw_channel_list[index]?.channel_code,
    }

    return postWithdrawCalc(data)
  }

  const onFinish = (values: any) => {
    if (is_user_tax_related !== 'Y') return setVisible(true)
    if (is_sign_protocol !== 1) return setVisible2(true)

    trigWithDrawCalc(Number(values.quota)).then((e:any) => {
      setCalcInfo(e)
      confirmPay(values, e)
    })
  }

  const filterUrl = (value: string) => {
    return value === 'bankcard' ? BankPng : value === 'alipay' ? AlipayPng : ''
  }

  const checkUCoin = (_: any, value: number) => {
    if (value >= 100 && value <= 5000000) {
      return Promise.resolve()
    }
    return Promise.reject(new Error('单笔最小10,000，最大5,000,000'))
  }

  const filterChannelName = (name:string) => {
    return name === 'alipay' ? '支付宝' : '银行卡'
  }

  const confirmPay = (values: any, e: CalcInfoData) => {
    handler.current = Dialog.show({
      content: (
        <>
          <h3 className="dialog-title">确认提交</h3>
          <section>
            <p>提现方式：{filterChannelName(e.withdraw_channel)}</p>
            <p>账号：{e.withdraw_channel === 'alipay' ? e.withdraw_account : `尾号(${e.withdraw_account})`}</p>
            <p>提现金额：{filterMoney(e.amount)} 熊猫币</p>
            <p>服务费：{filterMoney(e.handling_fee_amount)} 熊猫币</p>
            <p>预估税金：<span>{filterMoney(e.tax_rate)} 熊猫币</span></p>
            <p>实际到账：<span>{filterMoney(e.real_amount)} 熊猫币</span></p>
          </section>
        </>
      ),
      // bodyClassName: 'new-dialog',
      // closeOnAction: true,
      actions: [
        [
          {
            key: 'cancel',
            text: '取消',
            onClick: () => {
              handler.current?.close()
            },
          },
          {
            key: 'confirm',
            text: '确定',
            bold: true,
            onClick: () => {
              const data = {
                platform_number,
                amount: Number(values.quota),
                withdraw_channel: withdraw_channel_list[active].channel_code,
              }

              postWithdrawApply(data).then(e => {
                handler.current?.close()
                history.push({pathname: '/result', state: e})
                // jumpPage('/result')
              })
            },
          },
        ],
      ],
    })
  }

  const [amount, setAmount] = useState<number>(0)
  const onChange = (num:any) => {
    const val = num ? num.replace(/^(0+)|[^\d]+/g,'') : ''
    const str = val.toString()
    const val2 = str.length > 7 ? str.slice(0, 7) : str
    setValue(val)
    setAmount(Number(val))

    debounce(() => {
      if (Number(val) >= 100 && Number(val) <= 5000000) {
        trigWithDrawCalc(Number(val2)).then((e:any) => {
          setCalcInfo(e)
        })
      } else {
        setCalcInfo(primaryVal)
      }
    }, val ? 200 : 2000)
  }

  const onEnterPress = () => {
    const dom = document.getElementById('coinInputId')
    dom?.blur()
  }

  const selectwithDrawMethod = (index:number) => {
    setActive(index)

    amount && trigWithDrawCalc(amount, index).then((e:any) => {
      setCalcInfo(e)
    })
  }

  const [visible, setVisible] = useState<boolean>(false)

  const toSign = () => {
    setMaskVisible(true)

    getSignAnchorTaxProtocal().then(e => {
      window.location.href = e.sign_url
    }).finally(() => setMaskVisible(false))
  }

  const [visible2, setVisible2] = useState<boolean>(false)

  const toSign2 = () => {
    setMaskVisible(true)

    getSignAnchorProtocal(guild_id).then(e => {
      window.location.href = e.sign_url
    }).finally(() => setMaskVisible(false))
  }

  return (
    <div className="use-withdraw-page">
      <NavBar title={sign.title} rightButton="提取记录" buttonClick={buttonClick} />

      <section className="withdraw-page">
        {/* <nav className="notify">通知：新增两个签约平台，云账户小额平台与云账户大额平台，小额平台转大额平台每年随时可进行切换一次。大额非自然年首次无法转小额。</nav> */}

        <div className="card my-info">
          <h3>
            <span>我的钱包</span>
            <button className="small-btn" onClick={() => jumpPage('/info')}>我的信息<RightOutline /></button>
          </h3>
          <p><span>我的余额：</span><span>{filterMoney(account.amount)} 熊猫币</span></p>
          <p><span>月剩余额度：</span><span>{filterMoney(account.month_quota)} 熊猫币</span></p>
        </div>

        <div className="card">
          <header>
            <h3>输入申请额度</h3>
          </header>
          <Form
            onFinish={onFinish}
            footer={
              <Button block type='submit' color='primary' size='large' disabled={!calcInfo.real_amount || Number(value) < 100 || Number(value) > 5000000}>
                立即提交
              </Button>
            }
          >
            <Form.Item
              name='quota'
              rules={[{ validator: checkUCoin }]}
            >
              <div className="u-coin-line">
                <span>熊猫币：</span>
                <Input id='coinInputId' type="number" onChange={onChange} onEnterPress={onEnterPress} placeholder='单笔最小10,000，最大5,000,000' value={value} />
              </div>
            </Form.Item>
            <p>实际到账：{filterMoney(calcInfo.real_amount)} 熊猫币</p>
            <Form.Item
              rules={[{ required: true, message: '请选择提取方式' }]}
            >
              <header>
                <h3>选择提取方式</h3>
                <p>今日剩余次数<span> {withdraw_channel_list[active]?.channel_code === 'alipay' ? account.alipay_withdraw_num : account.bank_card_withdraw_num} </span>次</p>
              </header>
              <section>
                {
                  withdraw_channel_list.map((item, index) => (
                    <div className={active === index ? 'active-btn' : ''} key={index} onClick={() => selectwithDrawMethod(index)}>
                      <Image src={filterUrl(item.channel_code)} fit='contain' />
                      <p>{item.channel_name}</p>
                    </div>
                  ))
                }
              </section>
            </Form.Item>
          </Form>

          <ul>
            <li>1、熊猫币提现服务费 {platform_info.service_rates}%</li>
            <li>2、需先提交银行信息并签约服务协议后提交</li>
            <li>3、提现将在1-3个工作日内到账</li>
            <li>4、每日仅可提现 1 次，单次限额 5.000.000，若审核失败熊猫币提取次数将一并退回</li>
            <li>5、咨询签约及打款请在微信公众号联系客服</li>
          </ul>
        </div>
      </section>

      {/* 小酒窝10月税务新规 */}
      <Modal
        visible={visible}
        className="tax-modal"
        closeOnMaskClick={true}
        content={
          <div className="tax-modal-content">
            <header>
              <h3>增值税及附加税申报授权<br />委托书协议签署</h3>

              <article>
                <Image src={editFilePng} fit='contain' />
                <span>《增值税及附加税申报授权委托书》</span>
              </article>

              <span className="btn" onClick={() => throttle(toSign)}>去签署</span>

              <p>为更合规地履行代扣代缴义务，需签署以上协议</p>
            </header>

            <section>
              <h2>【小酒窝】关于为平台内从业人员<br />代办增值税及附加税申报的公告</h2>

              <p>【小酒窝】（以下简称“本平台”）为便利广大从业人员依法履行纳税义务，根据《中华人民共和国税收征收管理法》及《国家税务总局关于优化平台经济税收征管服务有关事项的公告》（2025年第16号）等规定，现将本平台代办增值税及附加税申报有关事项公告如下：</p>

              <p className="title">一、适用对象</p>
              <p>1.在【小酒窝】注册、通过本平台开展经营活动并取得经营所得的自然人（以下简称“您”）。</p>
              <p>2.您已在本平台完成实名认证，并签署《涉税授权委托书》，授权本平台代为办理增值税及附加税申报及缴纳事宜。</p>

              <p className="title">二、代办内容</p>
              <p>1.税种范围：增值税、城市维护建设税、教育费附加、地方教育附加。</p>
              <p>2.申报周期：按月汇总申报，申报期限为次月15日前（遇法定假日顺延）。</p>
              <p>3.计税依据：以您通过本平台取得的经营收入为基础，按照现行小规模纳税人优惠政策计算应纳税额，按1%征收率计算增值税，并同步计征附加税。</p>
              <p>4.税款缴纳：应缴税款由本平台统一代扣，并代为向主管税务机关缴纳。</p>

              <p className="title">三、信息提供与查验</p>
              <p>1.您应确保身份信息、经营收入、成本费用等真实、准确、完整。</p>
              <p>2.本平台将在申报前通过站内信/短信/APP推送等方式向您发送《应纳税款明细表》，您应在2个工作日内确认或提出异议；逾期未确认的，视为无异议。</p>

              <p className="title">四、法律责任</p>
              <p>1.本平台仅在接受您授权范围内履行代办义务；因您提供虚假数据、未及时补足税款等导致的滞纳金、罚款及其他法律责任，由您自行承担。</p>
              <p>2.若税收政策调整，本平台将按新规定同步调整计税规则，并通过公告、站内信等形式提前7个工作日通知您。</p>

              <p className="title">五、咨询与投诉</p>
              <p>1.客服通道：【客服电话 / 在线客服入口】，服务时间：每日 0:00-24:00。</p>
              <p>2.税务咨询：可拨打12366纳税缴费服务热线或登录电子税务局。</p>
              <p>如发现本平台代办行为存在差错，请在税款缴纳之日起30日内通过上述渠道反馈，我们将在3个工作日内予以回复。</p>

              <p className="title">六、生效时间</p>
              <p>本公告自【2025年10月10日】起施行，替代本平台以往发布的所有同类公告。若后续国家法律法规或主管税务机关另有要求，本平台将及时修订并公示。</p>
              <p>感谢您的理解与配合！</p>

              <footer>
                <p>【小酒窝语音】</p>
                <p>2025年10 月 10日</p>
              </footer>
            </section>
          </div>
        }
        closeOnAction
        onClose={() => {
          setVisible(false)
        }}
      />

      {/* 主播入驻协议 */}
      <Modal
        visible={visible2}
        className="residency-modal"
        closeOnMaskClick={true}
        content={
          <div className="residency-modal-content">
            <header>
              <span>协议签署</span>
              <CloseCircleOutline onClick={() => setVisible2(false)} />
            </header>

            <section>
              <div>
                <aside>
                  <Image src={editFilePng} fit='contain' />
                  <h4>《主播入驻协议》</h4>
                </aside>

                <span className="sign-btn" onClick={toSign2}>去签署</span>
              </div>

              <p>为保证双方权益需签署以上协议方可操作下一步</p>
            </section>
          </div>
        }
        closeOnAction
        onClose={() => setVisible2(false)}
      />

      {/* loading */}
      <Mask visible={maskVisible} onMaskClick={() => setMaskVisible(false)}>
        <div className="mask-content">
          <h3>正在跳转...</h3>
          <SpinLoading color="white" />
        </div>
      </Mask>
    </div>
  );
}

export default Withdraw